var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconmain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25187 19.0038C9.21833 19.0038 10.0018 18.2203 10.0018 17.2539C10.0018 16.2874 9.21833 15.5039 8.25187 15.5039C7.28542 15.5039 6.50195 16.2874 6.50195 17.2539C6.50195 18.2203 7.28542 19.0038 8.25187 19.0038Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8759 19.0038C16.8424 19.0038 17.6258 18.2203 17.6258 17.2539C17.6258 16.2874 16.8424 15.5039 15.8759 15.5039C14.9094 15.5039 14.126 16.2874 14.126 17.2539C14.126 18.2203 14.9094 19.0038 15.8759 19.0038Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19533 3.37134L6.26314 9.9185C6.58103 10.9246 6.73946 11.4277 7.045 11.8001C7.31248 12.1294 7.66122 12.3835 8.05524 12.5409C8.50275 12.7188 9.02948 12.7188 10.085 12.7188H14.0509C15.1064 12.7188 15.6331 12.7188 16.0796 12.5409C16.4746 12.3835 16.8223 12.1294 17.0908 11.8001C17.3954 11.4277 17.5538 10.9246 17.8727 9.9185L18.2935 8.5852L18.5404 7.79716L18.8809 6.71694C19.0024 6.33166 19.0315 5.92317 18.9657 5.52458C18.8999 5.12598 18.7412 4.74848 18.5023 4.42266C18.2635 4.09685 17.9513 3.83188 17.5909 3.64923C17.2306 3.46658 16.8323 3.37137 16.4283 3.37134H4.19533ZM4.19533 3.37134L4.18401 3.33328C4.14057 3.18776 4.09254 3.04366 4.03999 2.90119C3.83171 2.37398 3.47853 1.91646 3.02123 1.58149C2.56394 1.24653 2.02121 1.04778 1.45574 1.00823C1.34978 1 1.23353 1 1 1",
    stroke: "#2B2B2B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconmain);
export default __webpack_public_path__ + "static/media/cartIconmain.5f9c2d18ebce9e7254e61e05d1237a4f.svg";
export { ForwardRef as ReactComponent };